/**
 * Shared utilities for the Data Discovery module
 */

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isValidUUID(value: string): boolean {
  return UUID_REGEX.test(value)
}

export const dbTypeLabels: Record<string, string> = {
  POSTGRESQL: 'PostgreSQL',
  MSSQL: 'SQL Server',
}

export function formatRelativeTime(timestamp: string | null): string {
  if (!timestamp) return 'Never'

  const date = new Date(timestamp)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)

  if (diffMins < 1) return 'Just now'
  if (diffMins < 60) return `${diffMins}m ago`

  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h ago`

  const diffDays = Math.floor(diffHours / 24)
  if (diffDays < 7) return `${diffDays}d ago`

  return date.toLocaleDateString()
}

export function formatTimestamp(ts: string | null): string {
  if (!ts) return 'Never'
  return new Date(ts).toLocaleString()
}

export function formatDuration(
  startedAt: string | null,
  completedAt: string | null
): string {
  if (!startedAt || !completedAt) return '-'
  const ms = new Date(completedAt).getTime() - new Date(startedAt).getTime()
  const seconds = Math.floor(ms / 1000)
  if (seconds < 60) return `${seconds}s`
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  return `${minutes}m ${remainingSeconds}s`
}

/**
 * Sanitize a CSV cell value to prevent formula injection.
 * Cells starting with =, +, -, @, \t, \r are prefixed with a single quote.
 */
export function sanitizeCSVCell(cell: string): string {
  const escaped = cell.replace(/"/g, '""')
  if (/^[=+\-@\t\r]/.test(escaped)) {
    return `"'${escaped}"`
  }
  return `"${escaped}"`
}
